import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { ExtensionType, utils, settings, extensions } from '@pixi/core';
import { LoaderParserPriority } from './LoaderParser.mjs';
var loadTxt = {
  extension: {
    type: ExtensionType.LoadParser,
    priority: LoaderParserPriority.Low
  },
  test: function test(url) {
    return utils.path.extname(url).includes(".txt");
  },
  load: function load(url) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response, txt;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return settings.ADAPTER.fetch(url);
          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.text();
          case 5:
            txt = _context.sent;
            return _context.abrupt("return", txt);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};
extensions.add(loadTxt);
export { loadTxt };